import initHeader from './globals/header-megamenu.js';
import inlineCart from './globals/inline-cart.js';

document.addEventListener("DOMContentLoaded", function () {  
  initHeader();
  inlineCart();
});
